import { render, staticRenderFns } from "./MemberSelect.vue?vue&type=template&id=64b3874c&"
import script from "./MemberSelect.vue?vue&type=script&lang=js&"
export * from "./MemberSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports